<template>
  <div class="signin position-relative">
    <div class="d-flex flex-column mt-3 mb-3 ml-4 mr-4">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-row align-items-center mb-3">
          <Logo/>
          <h1 class="ml-3 mr-1">Password Reset</h1>
        </div>
      </div>
      <h2 class="modal-subtitle mx-auto mb-4">Enter your email address to have a password reset link sent to your in-box.</h2>
      <input class="mb-2 mx-auto text-lowercase" v-model="email" placeholder="Email address" autocapitalize="off" inputmode="email">
      <p class="validation-error mb-2" v-if="showError">{{errorMessage}}</p>
      <div class="contact d-flex justify-content-center mb-3 pl-2 pr-2">
        <span v-if="showError">
          <span>Drop us a line at </span>
          <a href="mailto:support@aftv.co.uk" target="_blank">support@aftv.co.uk</a>
          <span> if you have problems with sign-in or registration</span>
        </span>
      </div>
      <div class="d-flex justify-content-center">
        <button class="secondary" width="auto" v-on:click="onClose">Cancel</button>
        <button class="primary" width="auto" v-on:click="onSend">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '../components/Logo.vue'
import { spinnakerApi } from '../js/SpinnakerApi.js'

const errInvalidEmailAddress = 'Please provide a valid email address.'
const errConfirmationPending = 'Please click the activation link in your confirmation email'
const errUnknownEmail = 'Email address not registered'
const errUnexpectedError = 'Failed to request password reset. Please try again later.'
const errCodeerrConfirmationPending = 267
const errCodeUnknownEmail = 241

export default {
  components: {
    Logo
  },
  props: ['defaultUsername'],
  name: 'PasswordResetRequest',
  data: function () {
    return {
      email: '',
      showError: false,
      errorMessage: errInvalidEmailAddress
    }
  },
  created: function () {
    this.email = this.defaultUsername || ''
  },
  methods: {
    onClose () {
      this.$modal.hide('password-reset-request-modal')
    },
    async onSend () {
      if (this.email === '') {
        this.errorMessage = errInvalidEmailAddress
        this.showError = true
        return
      }

      this.$store.commit('showLoading')

      try {
        // Make call
        console.info(`sending pwd request`)
        await spinnakerApi.passwordResetRequest(this.email.toLowerCase().trim())
        console.info(`pwd request sent`)

        this.$modal.hide('password-reset-request-modal')
        this.$store.commit('hideLoading')

        this.$store.commit(
          'showDialogue',
          {
            title: 'Password Reset',
            subtitle: 'Please check your email and follow the enclosed link.'
          }
        )
      } catch (err) {
        this.sendFailed(err)
      }
    },
    sendFailed (err) {
      this.$store.commit('hideLoading')
      this.$store.commit('isRegisteredUser', false)

      this.errorMessage = errUnexpectedError
      this.showError = true
      if (err && err.response && err.response.status === 400 &&
          err.response.data && err.response.data.errorCode) {
        switch (err.response.data.errorCode) {
          case errCodeUnknownEmail:
            this.errorMessage = errUnknownEmail
            break
          case errCodeerrConfirmationPending:
            this.errorMessage = errConfirmationPending
            break
        }
        this.errorMessage += ` [${err.response.data.errorCode}]`
      }
    }
  }
}
</script>

<style scoped></style>
